const _ = require('./enum');
const Regions = require('../regions/enum');

const subRegions = {
  [_.SOUTHERN_EUROPE]: {
    id: _.SOUTHERN_EUROPE,
    label: 'Southern Europe',
    code: 39,
    region: Regions.EUROPE,
  },
  [_.WESTERN_ASIA]: {
    id: _.WESTERN_ASIA,
    label: 'Western Asia',
    code: 145,
    region: Regions.ASIA,
  },
  [_.SOUTHERN_ASIA]: {
    id: _.SOUTHERN_ASIA,
    label: 'Southern Asia',
    code: 34,
    region: Regions.ASIA,
  },
  [_.LATIN_AMERICA_AND_THE_CARIBBEAN]: {
    id: _.LATIN_AMERICA_AND_THE_CARIBBEAN,
    label: 'Latin America and the Caribbean',
    code: 419,
    region: Regions.AMERICAS,
  },
  [_.SUB_SAHARAN_AFRICA]: {
    id: _.SUB_SAHARAN_AFRICA,
    label: 'Sub-Saharan Africa',
    code: 202,
    region: Regions.AFRICA,
  },
  [_.ANTARCTICA]: {
    id: _.ANTARCTICA,
    label: 'Antarctica',
    code: 10,
    region: Regions.ANTARCTICA,
  },
  [_.POLYNESIA]: {
    id: _.POLYNESIA,
    label: 'Polynesia',
    code: 61,
    region: Regions.OCEANIA,
  },
  [_.WESTERN_EUROPE]: {
    id: _.WESTERN_EUROPE,
    label: 'Western Europe',
    code: 155,
    region: Regions.EUROPE,
  },
  [_.AUSTRALIA_AND_NEW_ZEALAND]: {
    id: _.AUSTRALIA_AND_NEW_ZEALAND,
    label: 'Australia and New Zealand',
    code: 53,
    region: Regions.OCEANIA,
  },
  [_.NORTHERN_EUROPE]: {
    id: _.NORTHERN_EUROPE,
    label: 'Northern Europe',
    code: 154,
    region: Regions.EUROPE,
  },
  [_.EASTERN_EUROPE]: {
    id: _.EASTERN_EUROPE,
    label: 'Eastern Europe',
    code: 151,
    region: Regions.EUROPE,
  },
  [_.NORTHERN_AMERICA]: {
    id: _.NORTHERN_AMERICA,
    label: 'Northern America',
    code: 21,
    region: Regions.AMERICAS,
  },
  [_.SOUTH_EASTERN_ASIA]: {
    id: _.SOUTH_EASTERN_ASIA,
    label: 'South-eastern Asia',
    code: 35,
    region: Regions.ASIA,
  },
  [_.EASTERN_ASIA]: {
    id: _.EASTERN_ASIA,
    label: 'Eastern Asia',
    code: 30,
    region: Regions.ASIA,
  },
  [_.NORTHERN_AFRICA]: {
    id: _.NORTHERN_AFRICA,
    label: 'Northern Africa',
    code: 15,
    region: Regions.AFRICA,
  },
  [_.MELANESIA]: {
    id: _.MELANESIA,
    label: 'Melanesia',
    code: 54,
    region: Regions.OCEANIA,
  },
  [_.MICRONESIA]: {
    id: _.MICRONESIA,
    label: 'Micronesia',
    code: 57,
    region: Regions.OCEANIA,
  },
  [_.CENTRAL_ASIA]: {
    id: _.CENTRAL_ASIA,
    label: 'Central Asia',
    code: 143,
    region: Regions.ASIA,
  },
};

module.exports = subRegions;
